var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d18627b73b9c1166272082e75e3a03083ac8359e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-20-next@plant-for-the-planet"]={id:"d18627b73b9c1166272082e75e3a03083ac8359e"};
      